import React, { useState } from 'react';

const Sidebar = ({ sidebarItems, activeMenuItem, setActiveMenuItem }) => {
  const [hoveredMenu, setHoveredMenu] = useState(null);

  const handleSubMenuClick = (subMenuItem) => {
    setActiveMenuItem(subMenuItem);
  };

  return (
    <aside className="user-dashboard-sidebar">
      <nav>
        <ul className="sidebar-menu">
          {sidebarItems.map(({ icon: Icon, label, subItems }) => (
            <div
              key={label}
              className="sidebar-item-group"
              onMouseEnter={() => subItems && setHoveredMenu(label)}
              onMouseLeave={() => subItems && setHoveredMenu(null)}
            >
              <li
                className={activeMenuItem === label ? 'active' : ''}
                onClick={() => !subItems && setActiveMenuItem(label)}
              >
                <Icon className="sidebar-icon" />
                <span>{label}</span>
              </li>

              {subItems && hoveredMenu === label && (
                <ul className="sub-menu">
                  {subItems.map((subItem) => (
                    <li
                      key={subItem.label || subItem}
                      className={activeMenuItem === (subItem.label || subItem) ? 'active' : ''}
                      onClick={() => handleSubMenuClick(subItem.label || subItem)}
                    >
                      <span>{subItem.label || subItem}</span>
                    </li>
                  ))}
                </ul>
              )}
              <div className="sidebar-divider"></div>
            </div>
          ))}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
